function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.583 9.5A7.92 7.92 0 019.5 1.583 7.92 7.92 0 0117.417 9.5 7.92 7.92 0 019.5 17.417 7.92 7.92 0 011.583 9.5zm2.375 0l3.959 3.958 7.125-7.125-1.116-1.124-6.01 6.009-2.841-2.834L3.958 9.5z",
  fill: "#005646"
});

function SvgCheckCircleGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgCheckCircleGreen;